module.exports = __webpack_public_path__ + "img/value-hero.39cd649f.jpg";